import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterTrainsBySitePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'filterTrainsBySite',
})
export class FilterTrainsBySitePipe implements PipeTransform {
  /**
   * Takes trains array and filter by site id
   */
  transform(value: Array<any>, siteId) {
    return value.filter(function (item) {
      return (item.siteId === siteId);
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-trains-by-site/filter-trains-by-site.ts